<template>
    <section class="sidebar">
            <ul class="sidebar-menu" data-widget="tree">
                <!--<li class="treeview" v-for="network in userHabilitations.networksAuthorize">
                    <a href="#"><span>{{network.network}}</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left pull-right"></i>
                        </span>
                    </a>
                    <ul class="treeview-menu">
                        <li v-for="categoryLabel in network.categoriesAuthorize">
                            <router-link :to="{name: 'category', params: {category: categoryLabel, network: network.network}}">{{categoryLabel}}</router-link>
                        </li>
                    </ul>
                </li>-->
                <!--<li v-if="userIsAdmin">
                    <router-link :to="{name: 'administrationGestionUser'}">Habilitations
                    </router-link>
                </li>-->
                <li class="treeview" v-if="pam">
                    <a href="#"><span>Pam</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left pull-right"></i>
                        </span>
                    </a>
                    <ul class="treeview-menu">
                        <li>
                            <router-link :to="{name: 'pam'}">Pam
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'adminPam'}">Habilitations
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </section>
</template>

<script>

    export default {
        components: {},
        data() {
            return {

            }
        },
        created() {
        },
        mounted() {

        },
        methods: {

        },
        computed: {
            userIsAdmin() {
                return this.$store.storeAuth.getters.isAdmin
            },
            pam() {
                return this.$store.storeAuth.getters.pam
            },
            userHabilitations() {
                return this.$store.storeAuth.getters.getTodReportingInformations
            }
        },
    }
</script>
